let isEnabled = false;

export function getIsAlternativeRegistrationEnabled(): boolean {
    return isEnabled;
}

export function setIsAlternativeRegistrationEnabled(value: boolean): void {
    isEnabled = value;
}

export function getDarklyExpId(): string {
    return `isAlternativeRegistrationEnabled${isEnabled}`;
}
